<template>
  <rest
    :remote="remote"
    :table-columns="tableColumns"
    :formInitialize="formInitialize"
    :form-rules="formRules"
    :exportable="true"
    :export-visible="true"
    :create-able="true" :update-able="true" :delete-able="true"
    :use-drawer="true"
    drawer-width="50%"
  >
  </rest>
</template>

<script>
import Rest from '../../components/Spring/Rest.vue'
export default {
  name: 'extConfigTemplates',
  components: { Rest },

  data () {
    return {
      remote: {
        path: 'channel',
        resource: this.$options.name,
        realtime: true,
        createLabel: '新增Ext模版'
      },
      formInitialize: {
        args: [],
        timeout: 3000
      },
      formRules: {
        dataKey: [{ required: true, message: '请填写 key' }],
        dataValue: [{ required: true, message: '请填写 value' }],
        name: [{ required: true, message: '请填写 name' }],
        dataDesc: [{ required: false, message: '请填写 desc' }]
      }
    }
  },
  computed: {
    tableColumns () {
      return [
        // { label: 'ID', prop: 'id', hiddenForm: true },
        { label: 'Key', prop: 'dataKey', minWidth: 180 },
        { label: 'Value', prop: 'dataValue', showOverflowTooltip: true, minWidth: 240 },
        { label: 'Name', prop: 'name', minWidth: 180 },
        { label: 'Desc', prop: 'dataDesc', type: 'textarea', showOverflowTooltip: true, minWidth: 260 }
      ]
    }
  },
  methods: {
  }
}
</script>

<style scoped>
</style>
